//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@nuskin/ns-core-styles/src/dist/main.css";

import { NsExpressiveLink } from "@nuskin/design-components";

export default {
  name: "NsFeature",
  components: {
    NsExpressiveLink
  },
  props: {
    /**
     * TItle text
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Description text
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Text of the call to action button
     */
    ctaText: {
      type: String,
      default: ""
    },
    /**
     * Url of the call to action button
     */
    ctaUrl: {
      type: String,
      default: ""
    },
    /**
     * If true, will open the link in a new tab
     */
    ctaOpensNewTab: Boolean,
    /**
     * Detirmines whether the call to action is a button or an expressive link
     * @values button, expressive-link
     */
    ctaType: {
      type: String,
      validator: prop => ["button", "expressive-link"].includes(prop),
      default: "button"
    },
    /**
     * Src url of the background image
     */
    imageSrc: {
      type: String,
      default: ""
    },
    /**
     * Detirmines whether the image will take up the full background or half
     * @values full, half
     */
    imageSize: {
      type: String,
      validator: prop => ["half", "full"].includes(prop),
      default: "full"
    },
    /**
     * Detirmines whether the text box will be on the left or right side
     * @values left, right
     */
    textAreaAlignment: {
      type: String,
      validator: prop => ["left", "right"].includes(prop),
      default: "left"
    },
    /**
     * Sets the background color behind the textbox when imageSize is set to 'half'
     */
    halfBackgroundColor: {
      type: String,
      default: "white"
    }
  },
  computed: {
    show() {
      return (
        !!this.title || !!this.description || !!this.ctaText || !!this.imageSrc
      );
    },
    isMobile() {
      return this.$mq === "mobile" || this.$mq === "phablet";
    },
    ctaVisible() {
      return !!this.ctaUrl && !!this.ctaText;
    }
  },
  methods: {
    ctaClicked() {
      window.open(this.ctaUrl, this.ctaOpensNewTab ? "_blank" : "_top");
    }
  }
};
